import React from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import { useNavigate } from 'react-router-dom';

export const Card = ({
  src,
  type,
  title,
  description1,
  description2,
  description3,
  link,
  spacey,
}: {
  src: string;
  type: string;
  title: string;
  description1: string;
  description2: string;
  description3: string;
  className?: string;
  link?: string;
  spacey?: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className={`flex flex-col md:flex-row w-[100%] md:h-[400px] justify-between bg-[#F7F7F7] rounded-[8px]`}
    >
      <div className="flex-1 p-[1rem] flex flex-col justify-between">
        <div>
          <h1>{type}</h1>
          <h3 className="text-[40px]">{title}</h3>
          <div className={`${spacey}`}>
            <p>{description1}</p>
            <p>{description2}</p>
            <p>{description3}</p>
          </div>
        </div>

        <div>
          <button
            className="p-0 w-fit text-[#1E90AA] mt-5 md:mt-0"
            onClick={() => link && navigate(link)}
          >
            {t('card.detailsButton')}
          </button>
        </div>
      </div>
      <div className={`flex-1 flex h-full self-end justify-end md:self-center`}>
        <img src={src} alt={title} className="card-image-fit rounded-r-[8px]" />
      </div>
    </div>
  );
};

export default Card;
